module.exports = __webpack_public_path__ + "static/aumento2-d59821656d7fc7a57286652cd51f9786.jpg";